// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import styles from './DividedContent.module.scss';

const DividedContent = ({ title, children }) => {
  return (
    <div className={styles.dividedContent}>
      <div className={styles.title}>{title}</div>
      <div className={styles.divider} />
      <div className={styles.content}>{children}</div>
    </div>
  );
};

DividedContent.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
};

DividedContent.defaultProps = {
  title: null,
  children: null,
};

export default DividedContent;
